import { type CSSProperties } from 'react';

import { SearchResultCardVtourIcon } from './SearchResultCardVtourIcon';
import { SearchResultCardPrice } from './SearchResultCardPrice';
import { SearchResultCardPreferences } from './SearchResultCardPreferences';
import { SearchResultCardLocation } from './SearchResultCardLocation';
import { SearchResultCardLink } from './SearchResultCardLink';
import { SearchResultCardImageCarousel } from './SearchResultCardImageCarousel';
import { SearchResultCardHeadline } from './SearchResultCardHeadline';
import { SearchResultCardFavoriteButton } from './SearchResultCardFavoriteButton';
import { SearchResultCardContent } from './SearchResultCardContent';
import { SearchResultCardBadges } from './SearchResultCardBadges';
import { SearchResultCardAttributes } from './SearchResultCardAttributes';
import { SearchResultCardArticleWrapper } from './SearchResultCardArticleWrapper';
import { SearchResultCardApproximateLocation } from './SearchResultCardApproximateLocation';

import styles from './SearchResultCardImage.module.css';

export type { Attribute } from './SearchResultCard.types';

export const DefaultSearchResultCard = ({ style }: { style?: CSSProperties }) => (
  <SearchResultCardArticleWrapper style={style}>
    <div className={styles.imageWrapper}>
      <SearchResultCardImageCarousel />
      <SearchResultCardVtourIcon />
      <SearchResultCardBadges />
      <SearchResultCardFavoriteButton />
    </div>
    <SearchResultCardContent>
      <SearchResultCardPreferences />
      <SearchResultCardLocation />
      <SearchResultCardHeadline />
      <SearchResultCardPrice />
      <SearchResultCardAttributes />
      <SearchResultCardLink />
    </SearchResultCardContent>
    <SearchResultCardApproximateLocation />
  </SearchResultCardArticleWrapper>
);
